import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "semantic-ui-css/semantic.min.css";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import PWAPrompt from "react-ios-pwa-prompt";
import ScrollManager from "./ScrollManager.js";
import StorefrontNavigation from "./Components/Storefront/Navigation/StorefrontNavigation";
import ProductPageWarmup from "./Components/common/ProductPageWarmup";
import { cleanDevelopmentTemplate } from "./Helpers/cleanDevelopmentTemplate";

if (process.env.NODE_ENV === "development") cleanDevelopmentTemplate(document);

if (process.env.NODE_ENV === "production")
  Sentry.init({
    dsn: "https://58d17c868526410f9ff401e6da53b5e4@o918783.ingest.sentry.io/5864200",
    integrations: [new Integrations.BrowserTracing()],
    release: "1",
    beforeSend: (event, hint) => {
      delete event.dist;
      return event;
    },
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
  });

if (typeof Object.assign !== "function") {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
      // .length of function is 2
      if (target === null || target === undefined) {
        throw new TypeError("Cannot convert undefined or null to object");
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource !== null && nextSource !== undefined) {
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true,
  });
}

if (!Object.entries)
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array

    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];
    return resArray;
  };
console.disableYellowBox = true;
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<></>} persistor={persistor}>
      <BrowserRouter>
        <StorefrontNavigation>
        <ScrollManager />
        <ProductPageWarmup />
        <App />
        {(window.location.hostname?.includes("store.oakberryqa.com") ||
          window.location.hostname?.includes("enable.qa")) &&
          !window.location.hostname?.includes("plazahollandi.enable.qa") && (
            <PWAPrompt />
          )}
        </StorefrontNavigation>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
